/* Ayudate · Sesión del dashboard de tutor
   El token de login vive en localStorage, no en memoria: así un F5 o
   cerrar y volver a abrir la pestaña no saca al tutor de su propio
   dashboard. El servidor es la única fuente de verdad sobre si ese token
   sigue siendo válido (ver COL_CREDENCIALES.sessionExpiracion en
   apps-script.gs) — esto es solo dónde vive del lado del navegador. */

const CLAVE = "ayudate_sesion_tutor";

export function guardarSesionTutor(token, idTutor) {
  localStorage.setItem(CLAVE, JSON.stringify({ token, idTutor }));
}

export function leerSesionTutor() {
  try {
    const cruda = localStorage.getItem(CLAVE);
    if (!cruda) return null;
    const s = JSON.parse(cruda);
    return s?.token ? s : null;
  } catch {
    return null;
  }
}

export function borrarSesionTutor() {
  localStorage.removeItem(CLAVE);
}
